export default "__VITE_ASSET__CBTi3cJq__"